module.exports = __webpack_public_path__ + "img/richs-logo.af29f30c.png";